function hasCloudinaryTransform(segment) {
  return (
    segment &&
    !/^v\d+$/.test(segment) &&
    /(^|,)(c_|dpr_|f_|h_|q_|w_)/.test(segment)
  );
}

export function getOptimizedCloudinaryUrl(url, width = 640, height = 420) {
  if (!url || !url.includes("/upload/")) return url || "";

  const [prefix, uploadPath] = url.split("/upload/");
  const pathParts = uploadPath.split("/");

  if (hasCloudinaryTransform(pathParts[0])) {
    pathParts.shift();
  }

  return `${prefix}/upload/f_auto,q_auto:good,c_fit,w_${width},h_${height}/${pathParts.join(
    "/",
  )}`;
}

export function getCloudinarySrcSet(url, widths, aspectRatio) {
  if (!url || !url.includes("/upload/")) return "";

  return widths
    .map((width) => {
      const height = Math.round(width / aspectRatio);
      return `${getOptimizedCloudinaryUrl(url, width, height)} ${width}w`;
    })
    .join(", ");
}
